/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    export interface IGetRecruitedService {
        getRecruitedAfterLogin: (organizationId: string, getRecruited?: boolean) => boolean;
        clear: () => void;

        getRecruited: boolean;
        orginizationId: string;

    }
    
    class GetRecruitedService implements IGetRecruitedService {
        static $inject: string[] = [];
        static serviceId: string = "getRecruitedService";
        getRecruited: boolean = false;
        orginizationId: string;

        constructor() {
        }

        getRecruitedAfterLogin = (organizationId: string, getRecruited?: boolean) => {
            if (getRecruited != null) {
                this.getRecruited = true;
                this.orginizationId = organizationId;
                return false;
            }
            else {
                if (organizationId == this.orginizationId && this.getRecruited == true) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        clear = () => {
            this.getRecruited = false;
            this.orginizationId = "";
        };
    }

    angular.module("app").service(GetRecruitedService.serviceId, GetRecruitedService);
}